import { ICustomPrice, IPrice, IStripeProduct } from '../../../interface'

type GetPricesType = {
  products: IStripeProduct[]
  productIds: string | string[]
}

type AddPriceToAdditionalResourcesType = {
  products: ICustomPrice[]
  stripeProducts: IPrice[]
}

/**
 * Retrieves and sorts Stripe product prices based on product ID and visibility criteria.
 *
 * @param products - The array of Stripe products to search through.
 * @param productIds - The product IDs to match against the products.
 * @returns Sorted array of matching prices or null if none found.
 */
export const getStripeProductPrices = ({ products, productIds }: GetPricesType) => {
  const filteredProducts = products
    .flatMap((product) =>
      product.prices
        .filter(() => productIds.includes(product.id))
        .map((price) => ({
          ...price,
          productName: product.name
        }))
    )
    .sort((a, b) => (parseInt(a.metadata._sequence) < parseInt(b.metadata._sequence) ? 1 : -1))
  if (!filteredProducts.length) {
    return null
  }
  return filteredProducts
}

/**
 * Adds the unit_amount value to the given product.
 *
 * @param products - The array of additional educational resources.
 * @param stripeProducts - The array of Stripe products to search through.
 * @returns An array of additional educational resources with modified price.
 */
export const addPriceToAdditionalResources = ({ products, stripeProducts }: AddPriceToAdditionalResourcesType) => {
  return products.map((customProduct) => {
    const updatedProduct = { ...customProduct }
    if (updatedProduct.price !== undefined && updatedProduct.productId) {
      const productIds = updatedProduct.productId.split(',').map((id) => id.trim())
      const productFound = stripeProducts.find((product) => productIds.includes(product.boxId))
      if (productFound) {
        updatedProduct.price = productFound.unit_amount
      }
    }
    return updatedProduct
  })
}
